<template>
  <ProgressList :maintenance="maintenanceFinished" loadPage="finish" />
</template>

<script>
import { maintenanceActions } from '@/src/Utils/helper'
import moment from 'moment'
import ViewMaintenanceDetail from './ViewMaintenanceDetail.vue'
import ProgressList from './Components/ProgressList.vue'

export default {
  name: 'MaintenanceSummaryListFinish',
  props: {
    fleetCategoryOpt: {
      type: Array,
      default: () => [],
    },
    jobClassList: {
      type: Array,
      default: () => [],
    },
    statusList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ViewMaintenanceDetail,
    ProgressList,
  },
  data() {
    return {
      filterOptionSelected: 'jobClass',
      maintenanceFinished: {
        isLoading: false,
        dateRange: [
          new Date(moment().startOf('month')),
          new Date(moment().endOf('month')),
        ],
        params: {
          action: '',
          search: '',
          status: '',
          startDate: null,
          endDate: null,
          perPage: 25,
          page: 1,
          vehicleIds: [],
          jobTypeIds: [],
          jobClassIds: [],
        },
        data: [],
        meta: {
          perPage: 0,
          currentPage: 0,
          total: 0,
          totalPage: 0,
        },
      },
    }
  },
  methods: {
    ...maintenanceActions,
    mappingIdsToCode(data) {
      let dataTemp = []
      if (!data?.length) return ''
      data.forEach((el) => {
        dataTemp.push(el.code)
      })
      return dataTemp.toString()
    },
    async getMaintenanceFinishedList(page) {
      this.maintenanceFinished.isLoading = true
      this.maintenanceFinished.data = []
      this.maintenanceFinished.params.page = page || 1

      if (this.maintenanceFinished.selectedJob === 'job_class') {
        this.maintenanceFinished.params.jobTypeIds = []
      } else {
        this.maintenanceFinished.params.jobClassIds = []
      }
      const paramsQ = {
        search: this.maintenanceFinished.params.search,
        perPage: this.maintenanceFinished.params.perPage,
        page: this.maintenanceFinished.params.page,
        startDate: this.maintenanceFinished.params.startDate,
        endDate: this.maintenanceFinished.params.endDate,
        status: this.maintenanceFinished.params.status,
        vehicleIds: this.mappingIdsToCode(
          this.maintenanceFinished.params.vehicleIds
        ),
        jobTypeIds: this.mappingIdsToCode(
          this.maintenanceFinished.params.jobTypeIds
        ),
        jobClassIds: this.mappingIdsToCode(
          this.maintenanceFinished.params.jobClassIds
        ),
        startDate: moment(this.maintenanceFinished.dateRange[0]).format(
          'DD-MM-YYYY'
        ),
        endDate: moment(this.maintenanceFinished.dateRange[1]).format(
          'DD-MM-YYYY'
        ),
      }

      if (paramsQ.search === '') delete paramsQ.search

      if (paramsQ.status === '') delete paramsQ.status

      const res = await this.getMaintenanceFinished(paramsQ)
      if (res.status == 'success') {
        if (res.data.data && res.data.data.length > 0) {
          this.maintenanceFinished.data = res.data.data
          this.maintenanceFinished.meta.perPage = res.data.perPage
          this.maintenanceFinished.meta.currentPage = res.data.currentPage
          this.maintenanceFinished.meta.total = res.data.total
          this.maintenanceFinished.meta.totalPage = res.data.totalPage
        }
        this.maintenanceFinished.isLoading = false
      } else {
        this.maintenanceFinished.data = []
        this.maintenanceFinished.isLoading = false
        this.$swal(`Oops!`, res.data, 'error')
      }
    },
  },
  mounted() {
    this.getMaintenanceFinishedList()
  },
}
</script>

<style scoped>
.sticky-column {
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
}
.column-1 {
  left: 0;
}
.column-2 {
  left: 2.4rem;
}
.column-3 {
  left: 9.4rem;
}
</style>
